module.exports = __webpack_public_path__ + "img/detail_data.fd674bb6.png";